const installMediaQueryWatcher = (mediaQuery, changedCallback) => {
  const mq = window.matchMedia(mediaQuery);
  mq.addEventListener('change', e => changedCallback(e.matches));
  changedCallback(mq.matches);
};

window.xViewport = {
  innerWidth: 0,
  innerHeight: 0
}

const viewportObserver = new ResizeObserver(() => {
  window.xViewport.innerWidth = window.innerWidth;
  window.xViewport.innerHeight = window.innerHeight;
});

viewportObserver.observe(document.documentElement);

const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
  window.Eurus.loadedScript.add(name);
  
  (events => {
    const loadScript = () => {
      events.forEach(type => window.removeEventListener(type, loadScript));
      clearTimeout(autoloadScript);

      const initScript = () => {
        const script = document.createElement('script');
        script.setAttribute('src', src);
        script.setAttribute('defer', '');
        script.onload = () => {
          document.dispatchEvent(new CustomEvent(name + ' loaded'));
          onload();
        };

        document.head.appendChild(script);
      }

      if (requestVisualChange) {
        if (window.requestIdleCallback) {
          requestIdleCallback(initScript);
        } else {
          requestAnimationFrame(initScript);
        }
      } else {
        initScript();
      }
    };

    let autoloadScript;
    if (Shopify.designMode) {
      loadScript();
    } else {
      const wait = window.matchMedia('(min-width: 768px)').matches ? 1000 : 3000;
      events.forEach(type => window.addEventListener(type, loadScript, {once: true, passive: true}));
      autoloadScript = setTimeout(() => {
        loadScript();
      }, wait);
    }
  })(['mouseover', 'wheel', 'scroll', 'keydown']);
}

const getSectionInnerHTML = (html, selector = '.shopify-section') => {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

const xParseJSON = (jsonString) => {
  jsonString = String.raw`${jsonString}`;
  jsonString = jsonString.replaceAll("\\","\\\\").replaceAll('\\"', '\"');
  return JSON.parse(jsonString);
}

window.addEventListener("pageshow", () => {
  document.addEventListener('alpine:init', () => {
    if (Alpine.store('xMiniCart')) {
      if (Alpine.store('xMiniCart').needReload) {
        Alpine.store('xMiniCart').reLoad();
      }
      const isCartPage = document.getElementById("main-cart-items");
      if (isCartPage && Alpine.store('xMiniCart').needReload) {
        location.reload();
      }
      Alpine.store('xMiniCart').needReload = true;
    }
  })
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xVariantPickerSizeChart', {
      openSizeChart: false ,
      sizeChartFocus() {
        Alpine.store('xFocusElement').trapFocus('VariantPickerSizeChart','CloseVariantPickerSizeChart');
      },
      sizeChartRemoveFocus() {
        const activeElement = document.getElementById('OpenVariantPickerSizeChart');
        Alpine.store('xFocusElement').removeTrapFocus(activeElement);
        this.openSizeChart = false; 
        Alpine.store('xPopup').close();
      }
    })
    Alpine.store('xHelper', {
      toUpdate: [],
      requestControllers: new Map(),
      eventControllers: new Map(),
      fbtProductListDraft: [],
      cancelRequest(key) {
        const controller = this.requestControllers.get(key);
        if (controller) {
          controller.abort();
          this.requestControllers.delete(key);
        }
      },
      cancelEvent(key) {
        const controller = this.eventControllers.get(key);
        if (controller) {
          controller.abort();
          this.eventControllers.delete(key);
        }
      },
      formatMoney(amount, formatString) {
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let value = this.formatWithDelimiters(amount, 2);
        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = this.formatWithDelimiters(amount, 2);
            break;
          case 'amount_no_decimals':
            value = this.formatWithDelimiters(amount, 0);
            break;
          case 'amount_with_comma_separator':
            value = this.formatWithDelimiters(amount, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = this.formatWithDelimiters(amount, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator ':
            value = this.formatWithDelimiters(amount, 2, "'", '.');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = this.formatWithDelimiters(amount, 0, ' ', ',')
            break;
          case 'amount_with_space_separator':
            value = this.formatWithDelimiters(amount, 2, ' ', ',')
            break;
          case 'amount_with_period_and_space_separator':
            value = this.formatWithDelimiters(amount, 2, ' ', '.')
            break;
        } 
        return formatString.replace(placeholderRegex, value);
      },
      defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      },
      formatWithDelimiters(number, precision, thousands, decimal) {
        precision = this.defaultOption(precision, 2);
        thousands = this.defaultOption(thousands, ',');
        decimal   = this.defaultOption(decimal, '.');
    
        if (isNaN(number) || number == null) { return 0; }
        number = (number/100.0).toFixed(precision);
    
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
    
        return dollars + cents;
      },
      countdown(configs, callback) {
        const maxAttempt = 100;

        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        let reset = configs.reset;
        let duration = configs.duration;
        let endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
          if (reset) {
            endDate = new Date(startTime + duration);
            endTime = endDate.getTime();
          }
        } else {
          if (reset) {
            startTime = endTime;
            endDate = new Date(startTime + duration);
            endTime = endDate.getTime();
          } else {
            startTime = new Date().getTime();
          }
        }

        if (new Date().getTime() < startTime) {
          callback(false, 0, 0, 0, 0);
          return;
        }

        const startInterval = () => {
          let x = setInterval(() => {
            let now = new Date().getTime();
            let distance = 0;

            distance = endTime - now;
            if (distance < 0) {
              clearInterval(x);
              if (reset) {
                let attempt = 0;
                while (distance < 0 && attempt < maxAttempt) {
                  attempt++;
                  if (attempt == 1) {
                    let elapsed = now - startTime;
                    let loopOffset = Math.floor(elapsed / duration) - 1;

                    startTime = startTime + loopOffset * duration;
                  } else {
                    startTime = endTime;
                  }
                  endDate = new Date(startTime + duration);
                  endTime = endDate.getTime();
                  distance = endTime - now;
                }
                if (attempt >= maxAttempt) {
                  callback(false, 0, 0, 0, 0);
                  return;
                }
                startInterval();
              } else {
                callback(false, 0, 0, 0, 0);
                return;
              }
            }
            if (distance > 0) {
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              var seconds = Math.floor((distance % (1000 * 60)) / 1000);

              minutes = minutes < 10 ? '0' + minutes : '' + minutes;
              seconds = seconds < 10 ? '0' + seconds : '' + seconds;

              callback(true, seconds, minutes, hours, days);
            }
          }, 1000);
        }

        startInterval();
      },
      canShow(configs) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else {
          startTime = new Date().getTime();
        }
        let now = new Date().getTime();
        let distance = endTime - now;
        if (distance < 0 || startTime > now) {
          return false;
        } 
        return true;
      },
      handleTime(configs) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else {
          startTime = new Date().getTime();
        }
        let now = new Date().getTime();
        let distance = endTime - now;
        return { "startTime": startTime, "endTime": endTime, "now": now, "distance": distance};
      },
      centerElement(el) {
        let resizeTimeout;
        let currTranslate = 0;
    
        const update = () => {
          window.requestAnimationFrame(() => {
            const rect = el.getBoundingClientRect();
            const translate = rect.left + Math.abs(currTranslate) - (document.documentElement.clientWidth - rect.width) / 2;
            el.style.transform = `translateX(-${translate}px)`;
            currTranslate = translate;
          })
        };
    
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(update, 150);
        });

        update();
      }
    });
    Alpine.store('xInit', {
      runDispatch: true,
      init() {
        const fire = () => {
          if (!this.runDispatch) return;
          this.runDispatch = false;
          window.dispatchEvent(new CustomEvent('init-run'));
        };
        const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1000));
        idle(fire, { timeout: 1500 });
        ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(evt => {
          window.addEventListener(evt, fire, { once: true, passive: true });
        });
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xCart', () => ({
      t: '',
      loading: false,
      customFieldInitOpened: false,
      updateItemQty(itemId, line, inventory_policy, track_inventory, maxQty, willRemoveInsurance) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          if (track_inventory || inventory_policy !== "continue") {
            this._postUpdateItem(itemId, line, qty, maxQty);
          } else {
            this._postUpdateItem(itemId, line, qty, qty);
          }
        }
        if (willRemoveInsurance && qty <= 0) {
          this.clearCart(itemId);
          return;
        }
      },
      minusItemQty(itemId, line, inventory_policy, track_inventory, maxQty, willRemoveInsurance) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          if (qty > 0) {
            qty -= 1;
            document.getElementById(`cart-qty-${itemId}`).value = qty;
          }

          if (track_inventory || inventory_policy !== "continue") {
            this._postUpdateItem(itemId, line, qty, maxQty);
          } else {
            this._postUpdateItem(itemId, line, qty, qty);
          }
        }
        if (willRemoveInsurance && qty <= 0) {
          this.clearCart(itemId);
          return;
        }
      },
      plusItemQty(itemId, line, inventory_policy, track_inventory, maxQty) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          if (qty >= 0) {
            qty += 1;
            document.getElementById(`cart-qty-${itemId}`).value = qty;
          }

          if (track_inventory || inventory_policy !== "continue") {
            this._postUpdateItem(itemId, line, qty, maxQty);
          } else {
            this._postUpdateItem(itemId, line, qty, qty);
          }
        }
      },
      removeItem(itemId, line, isShippingInsurance) {
        this._postUpdateItem(itemId, line, 0, 0, 500, isShippingInsurance);
      },
      handleKeydown(evt, el) {
        if (evt.key !== 'Enter') return;
        evt.preventDefault();
        el.blur();
        el.focus();
      },
      _postUpdateItem(itemId, line, qty, maxQty, wait = 500, isShippingInsurance) {
        if (isShippingInsurance) {
          Alpine.store('xPopupInsurance').loading = true;
        };
        clearTimeout(this.t);

        const func = async () => {
          this.loading = true;
          await Alpine.store('xCartHelper').waitForCartUpdate();
          window.updatingCart = true;

          let removeEl = document.getElementById(`remove-${itemId}`);
          if(removeEl){
            removeEl.style.display = 'none';
          }
          document.getElementById(`loading-${itemId}`)?.classList?.remove('hidden');
          let updateData = {
            'line': `${line}`,
            'quantity': `${qty}`,
            'sections': Alpine.store('xCartHelper').getSectionsToRender().map(s => s.id),
            'sections_url': window.location.pathname
          };

          let productIds = [];

          fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateData)
          })
          .then(response => {
            return response.json()
          })
          .then(parsedState => {
            if (parsedState.status == '422') {
              this._addErrorMessage(itemId, parsedState.message);
              this.updateCart(line, itemId);
            } else {
              parsedState.items.forEach(item => { productIds.push(item.product_id); });
              this.updateCartUI(parsedState, itemId, line, qty);
            }
          })
          .finally(() => {
            window.updatingCart = false;
            productIds.forEach(id => { document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${id}`)); });
            if (isShippingInsurance) {
              Alpine.store('xPopupInsurance').loading = false;
            };
          });
        }

        this.t = setTimeout(() => {
          func();
        }, wait);
      },
      updateCartUI(parsedState, itemId, line, qty) {
        const items = document.querySelectorAll('.cart-item');
        if (parsedState.errors) {
          this._addErrorMessage(itemId, parsedState.errors);
          return;
        }
        Alpine.store('xCartHelper').reRenderSections(parsedState.sections);
        Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);

        const currentItemCount = Alpine.store('xCartHelper').currentItemCount
        Alpine.store('xCartHelper').currentItemCount = parsedState.item_count;
        if (currentItemCount != parsedState.item_count) {
          document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
        }

        const lineItemError = document.getElementById(`LineItemError-${itemId}`);
        if (lineItemError) {lineItemError.classList.add('hidden');}
        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        
        if (items.length === parsedState.items.length && updatedValue !== parseInt(qty)) {
          let message = '';
          if (typeof updatedValue === 'undefined') {
            message = window.Eurus.cart_error;
          } else {
            message = window.Eurus.cart_quantity_error_html.replace('[quantity]', updatedValue);
          }
          this._addErrorMessage(itemId, message);
        }
        let loadingEl = document.getElementById(`loading-${itemId}`);
        let removeEl = document.getElementById(`remove-${itemId}`);
        if(removeEl){
          removeEl.style.display = 'block';
        }
        if (loadingEl) {
          loadingEl.classList.add('hidden');
        }
        this.loading = false;
      },
      updateCart(line, itemId) {
        let url = ''
        if (window.location.pathname !== '/cart'){
          url = `${window.location.pathname}?section_id=cart-drawer`
        } else {
          url = `${window.location.pathname}`
        }
        fetch(url)
        .then(reponse => {
          return reponse.text();
        })
        .then(response => {
          const parser = new DOMParser();
          const html = parser.parseFromString(response,'text/html');
          
          const rpCartFooter = html.getElementById('main-cart-footer');
          const cartFooter = document.getElementById('main-cart-footer');
          if (rpCartFooter && cartFooter) {
            cartFooter.innerHTML = rpCartFooter.innerHTML;
          }
          const rpItemInput = html.querySelector('.cart-item-qty-' + line);
          const itemInput = document.querySelector('.cart-item-qty-' + line);
          if (rpItemInput && itemInput) {
            itemInput.value = rpItemInput.value;
          }
          const rpItemTotal = html.querySelector('.cart-item-price-' + line);
          const itemTotal = document.querySelector('.cart-item-price-' + line);
          if (itemTotal && rpItemTotal) {
            itemTotal.innerHTML = rpItemTotal.innerHTML;
          }
          const rpPriceTotal = html.querySelector('.cart-drawer-price-total');
          const priceTotal = document.querySelector('.cart-drawer-price-total');
          if (rpPriceTotal && priceTotal) {
            priceTotal.innerHTML = rpPriceTotal.innerHTML;
          }
          const rpCartIcon = html.getElementById('cart-icon-bubble');
          const cartIcon = document.getElementById('cart-icon-bubble');
          if (cartIcon && rpCartIcon) {
            cartIcon.innerHTML = rpCartIcon.innerHTML;
          }
        }).finally(() => {
          let loadingEl = document.getElementById(`loading-${itemId}`);
          if (loadingEl) {
            loadingEl.classList.add('hidden');
          }
          this.loading = false;
        });
      },
      clearCart(itemId) {
        let removeEl = document.getElementById(`remove-${itemId}`);
        if(removeEl){
          removeEl.style.display = 'none';
        }
        document.getElementById(`loading-${itemId}`)?.classList?.remove('hidden');

        fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body:  JSON.stringify({ "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
        }).then((response) => {
          return response.json();
        }).then((response) => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              Alpine.store('xCartHelper').reRenderSections(response.sections);
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            }, 0)
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
          document.cookie = `eurus_insurance=; path=/`;
        })
      },
      async addShippingInsurance(productId) {
        Alpine.store('xPopupInsurance').loading = true;
        Alpine.store('xPopupInsurance').openInsuranceNoti = false;
        let item = [{
          id: productId,
          quantity: 1
        }];
        await Alpine.store('xCartHelper').waitForCartUpdate();
        window.updatingCart = true;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body:  JSON.stringify({ "items": item, "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
        }).then((response) => {
          return response.json();
        }).then((response) => {
          Alpine.store('xCartHelper').reRenderSections(response.sections);
          document.dispatchEvent(new CustomEvent("eurus:product:added", {
            detail: {
              product: response.items
            }
          }));
          Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
        })
        .catch((error) => {
          document.dispatchEvent(new CustomEvent("eurus:product:add-failed", {
            detail: {
              errorMessage: error
            }
          }));
          console.error('Error:', error);
        }).finally(() => {
          window.updatingCart = false;
          document.cookie = `eurus_insurance=${productId}; path=/`;
          Alpine.store('xPopupInsurance').loading = false;
          Alpine.store('xPopupInsurance').openInsuranceNotification()
        })
      },
      updateEstimateShippingAll(el) {
        const cartItems = el.getElementsByClassName('cart-item');
        Array.from(cartItems).forEach((item, index) => {
          window.requestAnimationFrame(() => {
            item.dispatchEvent(new CustomEvent(`eurus:cart-item:updateEstimateShipping:${index + 1}`));
          })
        });
      },
      waitForEstimateUpdate() {
        return new Promise(resolve => {
          function check() {
            if (!window.updatingEstimate) {
              resolve();
            } else {
              requestAnimationFrame(check);
            }
          }
          check();
        });
      },
      async updateEstimateShipping(el, line, qty, itemId, cutOffHour, cutOffMinute, hour, minutes, calculationType, daysText, dayText, hrText, minText, excludeDay, holidayList, currentLanguage, shippingInsuranceId, cartSize) {
        el.addEventListener(`eurus:cart-item:updateEstimateShipping:${line}`, async () => {
          if (shippingInsuranceId === itemId) return;
          const queryString = window.location.search;
          if (queryString.includes("share_cart:true") && !Alpine.store('xCartShare').shared) {
            return;
          }

          const key = el.getAttribute('x-data-update-estimate-key');
          let estimateProperty = el.getAttribute('x-data-update-estimate-property');
          let properties = JSON.parse(el.getAttribute('x-data-properties'));
          
          if (estimateProperty !== '' && estimateProperty.includes('time_to_cut_off')) {
            if (Alpine.store('xEstimateDelivery').noti == '') Alpine.store('xEstimateDelivery').countdownCutOffTime(cutOffHour, cutOffMinute, hour, minutes, calculationType, daysText, dayText, hrText, minText, excludeDay, holidayList, currentLanguage);
            estimateProperty = estimateProperty.replace('time_to_cut_off', Alpine.store('xEstimateDelivery').noti);
            properties[key] = estimateProperty;
            await this.waitForEstimateUpdate();
            window.updatingEstimate = true;
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ 
                'line': line, 
                'quantity': qty,
                'properties': properties
              })
            })
            .finally(() => {
              window.updatingEstimate = false;
            });
          }
        });
      },
      async updateDate(date) {
        await Alpine.store('xCartHelper').waitForCartUpdate();
        var formData = {
          'attributes': {
            'datetime-updated': `${date}`           
          }
        }; 
        fetch(Shopify.routes.root+'cart/update', {
          method:'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(formData)
        })
      },
      _addErrorMessage(itemId, message) {
        const lineItemError = document.getElementById(`LineItemError-${itemId}`);
        if (!lineItemError) return;
        lineItemError.classList.remove('hidden');
        lineItemError
          .getElementsByClassName('cart-item__error-text')[0]
          .innerHTML = message;
      },
      validateQty: function(number) {
        if((parseFloat(number) != parseInt(number)) && isNaN(number)) {
          return false
        }

        return true;
      }
    }));

    Alpine.store('xCartHelper', {
      currentItemCount: 0,
      validated: true,
      openField: '',
      openDeliveryDateField: '',
      openDiscountField: '',
      updateCart: async function(data, needValidate = false) {
        await Alpine.store('xCartHelper').waitForCartUpdate();
        const formData = JSON.stringify(data);
        fetch(Shopify.routes.root + 'cart/update', {
          method:'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: formData
        }).then((response) => {
          if (needValidate) this.validateCart();
          return response.json();
        }).then((response)=>{
          document.dispatchEvent(new CustomEvent('eurus:cart-drawer:order-note:update', {
            detail: { message: response.note }
          } ));
        });
      },
      cartValidationRequest() {
        this.validateCart();
        Alpine.store('xMiniCart').openCart();
      },
      validateCart: function(isCheckOut = false) {
        this.validated = true;

        document.dispatchEvent(new CustomEvent("eurus:cart:validate", {detail: {isCheckOut: isCheckOut}}));
      },
      goToCheckout(e) {
        this.validateCart(true);

        if (this.validated) {
          let formData = {
            'attributes': {
              'collection-pagination': null,
              'blog-pagination': null,
              'choose_option_id': null,
              'datetime-updated': null
            }
          };

          fetch(Shopify.routes.root + 'cart/update', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(formData)
          });
        } else {
          e.preventDefault();
        }
      },
      waitForCartUpdate() {
        return new Promise(resolve => {
          function check() {
            if (!window.updatingCart && !window.updatingEstimate) {
              resolve();
            } else {
              requestAnimationFrame(check);
            }
          }
          check();
        });
      },
      getSectionsToRender() {
        const cartItemEl = document.getElementById('main-cart-items');
        if (cartItemEl) {
          const templateId = cartItemEl.closest('.shopify-section').id
                              .replace('cart-items', '')
                              .replace('shopify-section-', '');

          return [
            {
              id: templateId + 'cart-items',
              selector: '#main-cart-items'
            },
            {
              id: templateId + 'cart-footer',
              selector: '#main-cart-footer'
            },
            {
              id: templateId + 'cart-upsell',
              selector: '#main-cart-upsell'
            },
            {
              id: "cart-icon-bubble",
              selector: '#cart-icon-bubble'
            },
            {
              id: 'mobile-cart-icon-bubble',
              selector: '#mobile-cart-icon-bubble'
            },
            {
              id: 'cart-icon-bubble-mobile-dock',
              selector: '#cart-icon-bubble-mobile-dock'
            }
          ];
        }

        return [
          {
            id: "cart-icon-bubble",
            selector: '#cart-icon-bubble'
          },
          {
            id: 'mobile-cart-icon-bubble',
            selector: '#mobile-cart-icon-bubble'
          },
          {
            id: 'cart-icon-bubble-mobile-dock',
            selector: '#cart-icon-bubble-mobile-dock'
          },
          {
            id: 'cart-drawer',
            selector: '#CartDrawer'
          }
        ];
      },
      async reRenderSections(sections) {
        let resSection = sections;
        const sectionsToRender = this.getSectionsToRender();
        if (!resSection) {
          const sectionsToRenderIds = sectionsToRender.map(s => s.id);

          if (sectionsToRender.length > 4) {
            const results = await Promise.all(
              sectionsToRenderIds.map(id =>
                fetch(`${window.location.pathname}?sections=${id}`).then(res => res.json())
              )
            );
            resSection = Object.assign({}, ...results);
          } else {
            const res = await fetch(`${window.location.pathname}?sections=${sectionsToRender}`);
            resSection = await res.json();
          }
        }
        this.getSectionsToRender().forEach((section => {
          section.selector.split(',').forEach((selector) => {
            const sectionElement = document.querySelector(selector);
            if (sectionElement) {
              if (resSection[section.id])
                sectionElement.innerHTML = getSectionInnerHTML(resSection[section.id], selector);
            }
          })
        }));
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    /**
     * Perfume search helpers:
     * - Keep typed Latin words (including "De")
     * - Append * on last Latin token for partial match (not Arabic — wildcards cause false hits)
     * - Expand Arabic alef/hamza forms with OR (امواج ↔ أمواج) — alef only, no ي/ئ swaps
     * - Keep the address bar + search input CLEAN (typed term only)
     */
    window.PerfyraArabicHamzaGroups = {
      'ا': ['ا', 'أ', 'إ', 'آ'],
      'أ': ['ا', 'أ', 'إ', 'آ'],
      'إ': ['ا', 'أ', 'إ', 'آ'],
      'آ': ['ا', 'أ', 'إ', 'آ'],
      'ٱ': ['ا', 'أ', 'إ', 'آ']
    };

    window.PerfyraNormalizeArabicText = function (str) {
      return String(str || '')
        .replace(/[أإآٱ]/g, 'ا')
        .replace(/ؤ/g, 'و')
        .replace(/ئ/g, 'ي')
        .replace(/ء/g, '')
        .replace(/ى/g, 'ي')
        .replace(/[\u064B-\u065F\u0670]/g, '')
        .replace(/\u0640/g, '');
    };

    window.PerfyraArabicWordVariants = function (word) {
      var raw = String(word || '').replace(/\*+/g, '');
      if (!raw) return [];

      // Typed first — used for clean display / URL
      var variants = [raw];
      var seen = {};
      seen[raw] = true;

      var add = function (v) {
        if (!v || seen[v]) return;
        seen[v] = true;
        variants.push(v);
      };

      var normalized = window.PerfyraNormalizeArabicText(raw);
      add(normalized);

      var groups = window.PerfyraArabicHamzaGroups;
      var base = normalized || raw;
      var chars = Array.from(base);

      // Only expand leading alef/hamza (أمواج ↔ امواج). Mid-word alef swaps add noise.
      var start = 0;
      if (chars.length > 2 && chars[0] === 'ا' && chars[1] === 'ل') start = 2;
      if (start < chars.length && groups[chars[start]]) {
        var alts = groups[chars[start]];
        for (var a = 0; a < alts.length; a++) {
          if (alts[a] === chars[start]) continue;
          var copy = chars.slice();
          copy[start] = alts[a];
          add(copy.join(''));
        }
      }

      if (/ء/.test(raw)) add(raw.replace(/ء/g, ''));

      // Keep Shopify query short
      return variants.slice(0, 3);
    };

    /**
     * EN ↔ AR brand synonyms so the same brand is found on both locales
     * (English titles vs Arabic titles).
     */
    window.PerfyraBrandSynonyms = [
      { en: ['louis vuitton', 'louis', 'lv'], ar: ['لويس فيتون', 'لويس فويتون', 'لويس'] },
      { en: ['nishane'], ar: ['نيشان', 'نيشانى'] },
      { en: ['mancera'], ar: ['مانسيرا'] },
      { en: ['essential parfums'], ar: ['اسنشال', 'إسنشال', 'اسنشال بارفام'] },
      { en: ['casamorati'], ar: ['كازاموراتي', 'كازاموراتى'] },
      { en: ['guerlain'], ar: ['غيرلان', 'جيرلان'] },
      { en: ['amouage'], ar: ['امواج', 'أمواج'] },
      { en: ['chanel'], ar: ['شانيل'] },
      { en: ['dior', 'christian dior', 'doir'], ar: ['ديور', 'كريستيان ديور'] },
      { en: ['versace'], ar: ['فيرساتشي', 'فيرزاتشي'] },
      { en: ['gucci'], ar: ['غوتشي'] },
      { en: ['tom ford'], ar: ['توم فورد'] },
      { en: ['creed'], ar: ['كريد'] },
      { en: ['ysl', 'yves saint laurent'], ar: ['إيف سان لوران', 'ايف سان لوران'] },
      { en: ['paco rabanne'], ar: ['باكو رابان'] },
      { en: ['jimmy choo'], ar: ['جيمي تشو'] },
      { en: ['lattafa'], ar: ['لطافة'] },
      { en: ['armaf'], ar: ['ارماف', 'أرماف'] },
      { en: ['rasasi'], ar: ['الرصاصي', 'رصاصي'] },
      { en: ['montblanc', 'mont blanc'], ar: ['مونت بلانك', 'مونتبلان'] },
      { en: ['hugo boss'], ar: ['هوغو بوس'] },
      { en: ['calvin klein'], ar: ['كالفن كلاين'] },
      { en: ['burberry'], ar: ['بربري'] },
      { en: ['givenchy'], ar: ['جيفنشي'] },
      { en: ['hermes', 'hermès'], ar: ['هيرمس', 'هيرميس'] },
      { en: ['prada'], ar: ['برادا'] },
      { en: ['valentino'], ar: ['فالنتينو'] },
      { en: ['carolina herrera'], ar: ['كارولينا هيريرا'] },
      { en: ['narciso rodriguez'], ar: ['نارسيسو رودريغيز'] },
      { en: ['jean paul gaultier'], ar: ['جان بول غوتييه'] },
      { en: ['issey miyake'], ar: ['إيسي مياكي'] },
      { en: ['kenzo'], ar: ['كينزو'] },
      { en: ['lancome', 'lancôme'], ar: ['لانكوم'] },
      { en: ['estee lauder'], ar: ['استي لودر', 'إستي لودر'] },
      { en: ['clinique'], ar: ['كلينيك'] },
      { en: ['al haramain', 'haramain'], ar: ['الحرمين'] },
      { en: ['ajmal'], ar: ['أجمل', 'اجمل'] },
      { en: ['swiss arabian'], ar: ['سويس عربيان'] },
      { en: ['m. micallef', 'm micallef', 'micallef'], ar: ['ام ميكاليف', 'ميكاليف'] },
      { en: ['parfums de marly', 'marly'], ar: ['بارفيومز دي مارلي', 'مارلي'] },
      { en: ['initio'], ar: ['انيشيو', 'إينيشيو'] },
      { en: ['xerjoff'], ar: ['زيرجوف'] },
      { en: ['byredo'], ar: ['بايريدو'] },
      { en: ['le labo'], ar: ['لو لابو'] },
      { en: ['diptyque'], ar: ['ديبتك', 'ديبتيك'] },
      { en: ['maison francis kurkdjian', 'mfk', 'kurkdjian'], ar: ['ميسون فرانسيس كوركدجيان'] },
      { en: ['kilian'], ar: ['كيليان'] },
      { en: ['roja', 'roja dove'], ar: ['روجا'] },
      { en: ['bond no 9', 'bond no. 9'], ar: ['بوند رقم 9'] },
      { en: ['memo paris', 'memo'], ar: ['ميمو'] },
      { en: ['atelier cologne'], ar: ['اتولييه كولون'] },
      { en: ['penhaligon', 'penhaligons'], ar: ['بنهاليغونز'] },
      { en: ['acqua di parma'], ar: ['اكوا دي بارما'] },
      { en: ['bvlgari', 'bulgari'], ar: ['بلغاري'] },
      { en: ['dolce gabbana', 'dolce & gabbana', 'd&g'], ar: ['دولتشي اند غابانا', 'دولتشي و غابانا'] },
      { en: ['jeroboam'], ar: ['جيروبوام'] },
      { en: ['gozo', 'gogo'], ar: ['غوزو'] },
      { en: ['armani', 'giorgio armani'], ar: ['ارماني'] },
      { en: ['sauvage'], ar: ['سوفاج'] }
    ];

    window.PerfyraNormalizeBrandKey = function (str) {
      var s = String(str || '').trim().toLowerCase();
      if (typeof window.PerfyraNormalizeArabicText === 'function') {
        s = window.PerfyraNormalizeArabicText(s);
      }
      return s.replace(/\s+/g, ' ').trim();
    };

    /** If query is a known brand (exact or prefix ≥4 chars), return all EN+AR terms (typed first). Else null. */
    window.PerfyraResolveBrandTerms = function (q) {
      var raw = String(q || '').trim().replace(/\*+/g, '').replace(/\s+/g, ' ');
      if (!raw || raw.length < 2) return null;
      var key = window.PerfyraNormalizeBrandKey(raw);
      var list = window.PerfyraBrandSynonyms || [];
      var best = null;
      var bestScore = -1;

      for (var i = 0; i < list.length; i++) {
        var brand = list[i];
        var en = brand.en || [];
        var ar = brand.ar || [];
        var score = -1;
        var scoreTerm = function (t) {
          var nk = window.PerfyraNormalizeBrandKey(t);
          if (!nk) return;
          if (nk === key) {
            score = Math.max(score, 1000 + nk.length);
            return;
          }
          if (key.length >= 4 && nk.indexOf(key) === 0) {
            score = Math.max(score, 500 + key.length);
          }
        };
        en.forEach(scoreTerm);
        ar.forEach(scoreTerm);
        if (score > bestScore) {
          bestScore = score;
          best = brand;
        }
      }
      if (!best || bestScore < 0) return null;

      var terms = [];
      var seen = {};
      var add = function (t) {
        var t0 = String(t || '').trim();
        if (!t0) return;
        var k = /[\u0600-\u06FF]/.test(t0) ? t0 : t0.toLowerCase();
        if (seen[k]) return;
        seen[k] = true;
        terms.push(t0);
      };
      add(raw);
      // Keep bilingual OR tiny — Shopify 502s on long (term OR term OR …) queries.
      if (best.en && best.en[0]) add(best.en[0]);
      if (best.ar && best.ar[0]) add(best.ar[0]);
      return terms.length ? terms.slice(0, 3) : null;
    };

    /** Brand suggestion labels for the current locale (prefix match on EN/AR synonyms). */
    window.PerfyraMatchBrandSuggestions = function (q, wantAr) {
      var raw = String(q || '').trim().replace(/\*+/g, '').replace(/\s+/g, ' ');
      if (!raw || raw.length < 2) return [];
      var key = window.PerfyraNormalizeBrandKey(raw);
      var list = window.PerfyraBrandSynonyms || [];
      var out = [];
      var seen = {};
      for (var i = 0; i < list.length; i++) {
        var brand = list[i];
        var en = brand.en || [];
        var ar = brand.ar || [];
        var hit = false;
        var check = function (t) {
          var nk = window.PerfyraNormalizeBrandKey(t);
          if (!nk) return;
          if (nk.indexOf(key) === 0 || key.indexOf(nk) === 0) hit = true;
        };
        en.forEach(check);
        ar.forEach(check);
        if (!hit) continue;
        var label = wantAr
          ? (ar[0] || en[0] || '')
          : (en[0] || ar[0] || '');
        if (!label) continue;
        var sk = window.PerfyraNormalizeBrandKey(label);
        if (seen[sk]) continue;
        seen[sk] = true;
        out.push(label);
      }
      return out;
    };

    /** Swap known EN brand tokens → Arabic (or leave as-is). */
    window.PerfyraLocalizeSuggestionText = function (text, wantAr) {
      var s = String(text || '').trim().replace(/\s+/g, ' ');
      if (!s || !wantAr) return s;
      if (/[\u0600-\u06FF]/.test(s) && !/[a-z]/i.test(s)) return s;
      var list = window.PerfyraBrandSynonyms || [];
      var pairs = [];
      for (var i = 0; i < list.length; i++) {
        var arLabel = (list[i].ar && list[i].ar[0]) || '';
        if (!arLabel) continue;
        (list[i].en || []).forEach(function (en) {
          if (en) pairs.push({ en: String(en).trim(), ar: arLabel });
        });
      }
      pairs.sort(function (a, b) { return b.en.length - a.en.length; });
      var out = s;
      for (var p = 0; p < pairs.length; p++) {
        (function (pair) {
          if (window.PerfyraNormalizeBrandKey(out) === window.PerfyraNormalizeBrandKey(pair.en)) {
            out = pair.ar;
            return;
          }
          var esc = pair.en.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\\?\s+/g, '\\s+');
          out = out.replace(new RegExp('(^|[\\s,;/|+])(' + esc + ')(?=$|[\\s,;/|+])', 'gi'), function (_m, pre) {
            return pre + pair.ar;
          });
        })(pairs[p]);
      }
      return out;
    };

    /**
     * Convert known EN↔AR aliases into ONE query in the current storefront language.
     * Never builds OR expressions. Caller keeps the visible input unchanged.
     */
    window.PerfyraLocalizeSearchQuery = function (query, locale) {
      var q = String(query || '').trim().replace(/\s+/g, ' ');
      if (!q) return q;
      if (typeof window.PerfyraIsExpandedSearchQuery === 'function' && window.PerfyraIsExpandedSearchQuery(q)) {
        return q;
      }

      var loc = String(locale || (window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase();
      var wantAr = /^ar/.test(loc);
      var list = window.PerfyraBrandSynonyms || [];
      var norm = function (s) {
        s = String(s || '').toLowerCase();
        if (typeof window.PerfyraNormalizeArabicText === 'function') s = window.PerfyraNormalizeArabicText(s);
        return s.replace(/\s+/g, ' ').trim();
      };
      var hasAr = function (s) { return /[\u0600-\u06FF]/.test(s); };
      var hasLat = function (s) { return /[a-z]/i.test(s); };
      var localeTerm = function (brand) {
        if (wantAr) return (brand.ar && brand.ar[0]) || (brand.en && brand.en[0]) || '';
        return (brand.en && brand.en[0]) || (brand.ar && brand.ar[0]) || '';
      };
      var aliasesOf = function (brand) {
        return [].concat(brand.en || [], brand.ar || []);
      };
      var toShopify = function (s) {
        s = String(s || q);
        if (/[\u0600-\u06FF]/.test(s)) {
          s = s.replace(/[أإآٱ]/g, 'ا').replace(/ى/g, 'ي')
            .replace(/[\u064B-\u065F\u0670]/g, '')
            .replace(/\u0640/g, '');
        }
        return s.replace(/\s+/g, ' ').trim() || q;
      };

      var qn = norm(q);
      var exact = [];
      for (var i = 0; i < list.length; i++) {
        var als = aliasesOf(list[i]);
        for (var a = 0; a < als.length; a++) {
          if (norm(als[a]) === qn) {
            exact.push(list[i]);
            break;
          }
        }
      }
      if (exact.length === 1) return toShopify(localeTerm(exact[0]) || q);

      var tokens = q.split(/\s+/).filter(Boolean);
      if (tokens.length > 1 || (hasAr(q) && hasLat(q))) {
        var out = [];
        var idx = 0;
        while (idx < tokens.length) {
          var matched = null;
          var used = 1;
          for (var take = Math.min(4, tokens.length - idx); take >= 1; take--) {
            var slice = tokens.slice(idx, idx + take).join(' ');
            var sn = norm(slice);
            for (var bi = 0; bi < list.length && !matched; bi++) {
              var bals = aliasesOf(list[bi]);
              for (var bj = 0; bj < bals.length; bj++) {
                if (norm(bals[bj]) === sn) {
                  matched = list[bi];
                  used = take;
                  break;
                }
              }
            }
            if (matched) break;
          }
          out.push(matched ? (localeTerm(matched) || tokens[idx]) : tokens[idx]);
          idx += used;
        }
        return toShopify(out.join(' '));
      }

      var typedAr = hasAr(q);
      var typedLat = hasLat(q);
      var sameLang = (wantAr && typedAr && !typedLat) || (!wantAr && typedLat && !typedAr);
      if (sameLang) return toShopify(q);

      var minLen = typedAr ? 3 : 4;
      if (qn.length < minLen) return toShopify(q);
      var prefixHits = [];
      for (var p = 0; p < list.length; p++) {
        var pals = aliasesOf(list[p]);
        for (var pa = 0; pa < pals.length; pa++) {
          var pn = norm(pals[pa]);
          if (pn && pn.indexOf(qn) === 0) {
            prefixHits.push(list[p]);
            break;
          }
        }
      }
      if (prefixHits.length === 1) return toShopify(localeTerm(prefixHits[0]) || q);
      return toShopify(q);
    };

    // Visible search box / URL: show only what the user typed (never the OR expansion)
    window.PerfyraDisplaySearchQuery = function (q) {
      var s = String(q || '').trim();
      if (!s) return '';
      try {
        var saved = sessionStorage.getItem('perfyra-search-display');
        if (saved && (/\bOR\b/i.test(s) || /[()]/.test(s))) return saved;
      } catch (e) {}
      if (/\bOR\b/i.test(s) || /[()]/.test(s)) {
        s = (s.split(/\s+OR\s+/i)[0] || s);
      }
      s = s
        .replace(/\*/g, '')
        .replace(/[()]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
      var parts = s.split(/\s+/).filter(Boolean);
      if (parts.length > 1 && /[\u0600-\u06FF]/.test(parts[0]) && typeof window.PerfyraNormalizeArabicText === 'function') {
        var base0 = window.PerfyraNormalizeArabicText(parts[0]);
        var allSameFamily = parts.every(function (p) {
          return window.PerfyraNormalizeArabicText(p) === base0;
        });
        if (allSameFamily) return parts[0];
      }
      return s;
    };

    window.PerfyraIsExpandedSearchQuery = function (q) {
      return /\bOR\b/i.test(q || '') || /\(/.test(q || '');
    };

    window.PerfyraBuildSearchUrl = function (qValue, searchParams) {
      var params = searchParams ? new URLSearchParams(searchParams.toString()) : new URLSearchParams(location.search);
      params.set('q', qValue);
      if (!params.get('type')) params.set('type', 'product');
      if (!params.get('options[prefix]')) params.set('options[prefix]', 'last');
      return location.pathname + '?' + params.toString() + location.hash;
    };

    /** Hide OR expansion from the address bar; keep typed term only */
    window.PerfyraCleanSearchUrl = function () {
      if (location.pathname.indexOf('/search') === -1) return null;
      var params = new URLSearchParams(location.search);
      var q = params.get('q') || '';
      if (!window.PerfyraIsExpandedSearchQuery(q)) return window.PerfyraDisplaySearchQuery(q) || q;

      var clean = null;
      try { clean = sessionStorage.getItem('perfyra-search-display'); } catch (e) {}
      if (!clean) clean = window.PerfyraDisplaySearchQuery(q);
      if (!clean) return null;

      try { sessionStorage.setItem('perfyra-search-display', clean); } catch (e) {}
      try { sessionStorage.setItem('perfyra-search-expanded', q); } catch (e) {}

      var nextUrl = window.PerfyraBuildSearchUrl(clean, params);
      // history.state marks this document as already loaded with expanded results
      // so Boot will not redirect again after replaceState
      history.replaceState({ perfyraHamzaExpanded: true, q: clean, servedExpanded: true }, '', nextUrl);

      try {
        if (document.title && /\bOR\b/i.test(document.title)) {
          document.title = document.title
            .replace(/\([^)]*OR[^)]*\)/gi, clean)
            .replace(/"[^"]*OR[^"]*"/gi, '"' + clean + '"');
        }
      } catch (e) {}

      return clean;
    };

    window.PerfyraCleanSearchInputs = function (forcedClean) {
      var saved = forcedClean || null;
      if (!saved) {
        try { saved = sessionStorage.getItem('perfyra-search-display'); } catch (e) {}
      }
      var inputs = document.querySelectorAll('input[name="q"][type="search"], input.input-search[name="q"]');
      inputs.forEach(function (el) {
        if (el.disabled || el.type === 'hidden') return;
        var next = saved || window.PerfyraDisplaySearchQuery(el.value);
        if (!next) return;
        if (next !== el.value) el.value = next;
      });
    };

    window.PerfyraCountSearchOrClauses = function (q) {
      var s = String(q || '');
      if (!s) return 0;
      var parts = s.split(/\s+OR\s+/i).filter(Boolean);
      return parts.length || 1;
    };

    /** Reject oversized OR expansions that 502 Shopify search. */
    window.PerfyraSafeSearchQuery = function (expanded, fallback) {
      var q = String(expanded || '').trim();
      var fb = String(fallback || '').trim();
      if (!q) return fb;
      var orCount = window.PerfyraCountSearchOrClauses(q);
      if (orCount > 3 || q.length > 90) return fb || q.split(/\s+OR\s+/i)[0].replace(/[()]/g, '').trim();
      return q;
    };

    window.PerfyraNormalizeSearchQuery = function (q, mode) {
      q = String(q || '').trim().replace(/\s+/g, ' ');
      if (!q) return q;
      q = q.replace(/^["«]+/, '').replace(/["»]+$/, '').trim();
      if (!q) return q;

      // Already expanded (filter/sort resubmit) — leave as-is unless unsafe
      if (window.PerfyraIsExpandedSearchQuery(q)) {
        return window.PerfyraSafeSearchQuery(q, window.PerfyraDisplaySearchQuery(q) || q);
      }

      // Keep explicit wildcard queries as-is. This is used for short
      // search terms like "ti*" where the full search page needs a prefix
      // match and must not normalize back to "ti" on boot.
      if (q.indexOf('*') !== -1) return q;

      var localized = (typeof window.PerfyraLocalizeSearchQuery === 'function')
        ? window.PerfyraLocalizeSearchQuery(q)
        : q;

      if (mode === 'suggest') {
        return String(localized || q).replace(/\*+/g, '');
      }

      // Full page: one localized query. Short Latin prefixes keep Shopify wildcard.
      var pageQ = String(localized || q).replace(/\*+/g, '').trim();
      if (!pageQ) return q;
      if (pageQ.indexOf(' ') === -1 && pageQ.length > 0 && pageQ.length < 3 && !/[\u0600-\u06FF]/.test(pageQ)) {
        return pageQ + '*';
      }
      return pageQ;
    };

    /** Legacy distance helper retained for callers outside the search matcher. */
    window.PerfyraLatinEditDistance = function (a, b) {
      a = String(a || '').toLowerCase();
      b = String(b || '').toLowerCase();
      if (a === b) return 0;
      var al = a.length;
      var bl = b.length;
      if (!al) return bl;
      if (!bl) return al;
      if (Math.abs(al - bl) > 1) return 99;
      var prev = new Array(bl + 1);
      var cur = new Array(bl + 1);
      var i;
      var j;
      for (j = 0; j <= bl; j++) prev[j] = j;
      for (i = 1; i <= al; i++) {
        cur[0] = i;
        for (j = 1; j <= bl; j++) {
          var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        }
        var tmp = prev;
        prev = cur;
        cur = tmp;
      }
      return prev[bl];
    };

    window.PerfyraIsSimpleSearchQuery = function (q) {
      q = String(q || '').trim();
      if (!q) return false;
      if (/\bOR\b/i.test(q) || q.indexOf('(') !== -1) return false;
      return q.replace(/\*+/g, '').trim().split(/\s+/).filter(Boolean).length === 1;
    };

    window.PerfyraProductMatchesSearch = function (haystack, query) {
      var normalize = function (value) {
        return window.PerfyraNormalizeBrandKey(value).replace(/\*/g, '').trim();
      };
      var text = normalize(haystack);
      var term = normalize(query);
      if (!term) return true;
      if (text.indexOf(term) !== -1) return true;
      // Translate known aliases, but never accept an unrelated fuzzy match.
      return ['en', 'ar'].some(function (locale) {
        var localized = normalize(window.PerfyraLocalizeSearchQuery(term, locale));
        return localized && text.indexOf(localized) !== -1;
      });
    };

    /** True when Shopify facet filters (price, brand, etc.) are applied */
    window.PerfyraHasActiveFacets = function () {
      try {
        if (document.querySelector('.active-filter-control')) return true;
      } catch (e) {}
      var params = new URLSearchParams(location.search);
      var skip = {
        q: true,
        type: true,
        page: true,
        section_id: true,
        sort_by: true,
        'options[prefix]': true
      };
      var keys = params.keys();
      var key = keys.next();
      while (!key.done) {
        var k = key.value;
        if (!skip[k] && (/^filter\./i.test(k) || /^filter_/i.test(k))) return true;
        key = keys.next();
      }
      return !!window.__perfyraFacetsActive;
    };

    window.PerfyraFilterSearchResults = function () {
      if (location.pathname.indexOf('/search') === -1) return;
      var params = new URLSearchParams(location.search);
      var q = params.get('q') || '';
      try {
        var saved = sessionStorage.getItem('perfyra-search-display');
        var served = sessionStorage.getItem('perfyra-search-expanded');
        if (saved && (q === saved || q === served)) q = saved;
      } catch (e) {}
      q = window.PerfyraDisplaySearchQuery(q) || q;

      var grid = document.getElementById('items-grid');
      var container = document.getElementById('ProductGridContainer');

      // Facet empty state (no grid) → 0 results, never keep stale "20"
      if (!grid) {
        window.__perfyraSearchLoadedCount = 0;
        if (typeof window.PerfyraHasActiveFacets === 'function' && window.PerfyraHasActiveFacets()) {
          window.__perfyraFacetResultCount = 0;
        }
        if (typeof window.PerfyraSyncSearchCounts === 'function') window.PerfyraSyncSearchCounts();
        return;
      }

      if (!q) return;

      var items = grid.querySelectorAll('[data-perfyra-search-item="product"]');
      var hidden = 0;
      Array.prototype.forEach.call(items, function (el) {
        var hay = (el.getAttribute('data-perfyra-search-haystack') || '').trim();
        if (!hay) {
          var titleEl = el.querySelector('[data-product-title], .card-information a, .card__heading a, a[href*="/products/"]');
          hay = ((titleEl && titleEl.textContent) || '').trim();
        }
        if (window.PerfyraProductMatchesSearch(hay, q)) {
          el.hidden = false;
          el.style.removeProperty('display');
        } else {
          el.hidden = true;
          el.style.setProperty('display', 'none', 'important');
          hidden++;
        }
      });

      window.__perfyraSearchLoadedCount = items.length - hidden;

      // All cards hidden by title filter while facets on → treat as empty
      if (items.length > 0 && window.__perfyraSearchLoadedCount === 0 && window.PerfyraHasActiveFacets()) {
        window.__perfyraFacetResultCount = 0;
      }

      if (typeof window.PerfyraSyncSearchCounts === 'function') {
        window.PerfyraSyncSearchCounts();
      }
    };

    /** Update Availability/Brand option counts (33) → title-matched total (29) */
    window.PerfyraSyncFacetOptionCounts = function (titleTotal) {
      if (location.pathname.indexOf('/search') === -1) return;
      if (typeof titleTotal !== 'number' || titleTotal < 0) return;

      var grid = document.getElementById('items-grid');
      var shopifyRaw = grid
        ? parseInt(grid.getAttribute('data-perfyra-shopify-total') || '', 10)
        : NaN;
      if (!isNaN(shopifyRaw) && shopifyRaw > 0) {
        window.__perfyraShopifyRawTotal = shopifyRaw;
      } else {
        shopifyRaw = window.__perfyraShopifyRawTotal;
      }

      var nodes = document.querySelectorAll('[data-perfyra-facet-count-num]');
      if (nodes.length) {
        Array.prototype.forEach.call(nodes, function (el) {
          var n = parseInt((el.textContent || '').replace(/,/g, ''), 10);
          if (isNaN(n) || n <= 0) return;
          // Shopify raw total (e.g. 33) or any count above title-matched total
          if ((shopifyRaw && n === shopifyRaw) || n > titleTotal) {
            el.textContent = String(titleTotal);
          }
        });
        return;
      }

      // Fallback when Liquid markup not yet updated: "Label (33)"
      var spans = document.querySelectorAll(
        '#FacetFiltersForm span.p-break-words, .form-aside span.p-break-words, .form-drawer span.p-break-words, .js-filter span.p-break-words'
      );
      Array.prototype.forEach.call(spans, function (span) {
        var t = span.textContent || '';
        var m = t.match(/^(.*)\((\d[\d,]*)\)\s*$/);
        if (!m) return;
        var n = parseInt(m[2].replace(/,/g, ''), 10);
        if (isNaN(n) || n <= 0) return;
        if ((shopifyRaw && n === shopifyRaw) || n > titleTotal) {
          span.textContent = m[1] + '(' + titleTotal + ')';
        }
      });
    };

    /** Filter bar = total; pagination = loaded/total — always title-matched, never Shopify raw count */
    window.PerfyraSyncSearchCounts = function () {
      if (location.pathname.indexOf('/search') === -1) return;
      var grid = document.getElementById('items-grid');
      var loaded = window.__perfyraSearchLoadedCount;
      if (typeof loaded !== 'number' && grid) {
        loaded = grid.querySelectorAll('[data-perfyra-search-item="product"]:not([hidden])').length;
      }
      if (typeof loaded !== 'number') loaded = 0;
      if (!grid) loaded = 0;

      var total;
      var facetsOn = typeof window.PerfyraHasActiveFacets === 'function' && window.PerfyraHasActiveFacets();

      if (facetsOn) {
        if (!grid) {
          total = 0;
          loaded = 0;
        } else {
          // Title-matched total only (Shopify results_count includes body/tag hits)
          total = window.__perfyraFacetTitleTotal;
          if (typeof total !== 'number') {
            total = loaded;
          } else if (loaded > total) {
            total = loaded;
            window.__perfyraFacetTitleTotal = total;
          }
        }
      } else {
        total = window.__perfyraFilteredTotal;
        if (typeof total !== 'number') {
          total = loaded;
        } else if (loaded > total) {
          total = loaded;
          window.__perfyraFilteredTotal = total;
        }
      }

      Array.prototype.forEach.call(
        document.querySelectorAll('[data-perfyra-search-count], #ProductCount, #ProductCount_header, #ProductCountDrawer'),
        function (el) {
          if (!el || !el.textContent) return;
          if (/\d/.test(el.textContent)) {
            el.textContent = el.textContent.replace(/\d[\d,]*/, String(Math.max(total, 0)));
          }
        }
      );

      Array.prototype.forEach.call(document.querySelectorAll('[data-perfyra-search-showing]'), function (node) {
        var t = node.textContent || '';
        if (/\d+\s*\/\s*\d+/.test(t)) {
          node.textContent = t.replace(/\d+\s*\/\s*\d+/, loaded + '/' + total);
        } else {
          var parts = t.match(/\d[\d,]*/g) || [];
          if (parts.length >= 2) {
            node.textContent = t.replace(parts[0], String(loaded)).replace(parts[1], String(total));
          }
        }
      });

      // Fix "In stock (33)" etc. inside filter dropdowns to match title-only total
      if (typeof window.PerfyraSyncFacetOptionCounts === 'function' && typeof total === 'number') {
        window.PerfyraSyncFacetOptionCounts(total);
      }
    };

    /**
     * Count title-matched products across ALL search pages (section HTML).
     * Always fetches each page when pages > 1 so Load-more DOM doesn't double-count.
     * Respects active facet params in the URL.
     */
    window.PerfyraFetchTitleMatchTotal = function () {
      var grid = document.getElementById('items-grid');
      if (!grid) return Promise.resolve(window.__perfyraSearchLoadedCount || 0);
      var loaded = typeof window.__perfyraSearchLoadedCount === 'number'
        ? window.__perfyraSearchLoadedCount
        : grid.querySelectorAll('[data-perfyra-search-item="product"]:not([hidden])').length;
      var pages = parseInt(grid.getAttribute('data-perfyra-pages') || '1', 10) || 1;
      if (pages <= 1) return Promise.resolve(loaded);
      var params = new URLSearchParams(location.search);
      var query = params.get('q') || '';
      params.set('q', window.PerfyraNormalizeSearchQuery(query, 'page'));
      params.set('section_id', grid.getAttribute('data-perfyra-section-id'));
      return (async function () {
        var total = 0;
        for (var page = 1; page <= pages; page++) {
          params.set('page', String(page));
          var response = await fetch(location.pathname + '?' + params.toString());
          if (!response.ok) throw new Error('Search count request failed');
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          total += Array.from(doc.querySelectorAll('[data-perfyra-search-item="product"]')).filter(function (item) {
            return window.PerfyraProductMatchesSearch(item.getAttribute('data-perfyra-search-haystack'), query);
          }).length;
        }
        return total;
      })().catch(function () { return loaded; });
    };

    /** After facet AJAX: recount title matches for filter + pagination UI */
    window.PerfyraRecountFacetTitleMatches = function () {
      if (location.pathname.indexOf('/search') === -1) return;
      if (typeof window.PerfyraHasActiveFacets !== 'function' || !window.PerfyraHasActiveFacets()) {
        window.__perfyraFacetTitleTotal = null;
        return;
      }

      if (typeof window.PerfyraFilterSearchResults === 'function') {
        window.PerfyraFilterSearchResults();
      }

      var loaded = window.__perfyraSearchLoadedCount || 0;
      window.__perfyraFacetTitleTotal = loaded;
      if (typeof window.PerfyraSyncSearchCounts === 'function') window.PerfyraSyncSearchCounts();

      if (typeof window.PerfyraFetchTitleMatchTotal !== 'function') return;
      var countUrl = location.href;
      window.PerfyraFetchTitleMatchTotal().then(function (n) {
        if (location.href !== countUrl) return;
        if (typeof window.PerfyraHasActiveFacets === 'function' && !window.PerfyraHasActiveFacets()) return;
        if (typeof n === 'number' && n >= 0) {
          window.__perfyraFacetTitleTotal = n;
          if (typeof window.PerfyraSyncSearchCounts === 'function') window.PerfyraSyncSearchCounts();
        }
      });
    };

    window.PerfyraBootSearchCounts = function () {
      if (location.pathname.indexOf('/search') === -1) return;
      if (window.__perfyraSearchCountsBooted) return;
      window.__perfyraSearchCountsBooted = true;

      var displayQ = '';
      try { displayQ = sessionStorage.getItem('perfyra-search-display') || ''; } catch (e) {}
      if (!displayQ) {
        var params0 = new URLSearchParams(location.search);
        displayQ = window.PerfyraDisplaySearchQuery(params0.get('q') || '') || '';
      }

      // Use cache immediately when present (skip when facets already active)
      try {
        var facetsOnBoot = typeof window.PerfyraHasActiveFacets === 'function' && window.PerfyraHasActiveFacets();
        var cached = !facetsOnBoot && displayQ ? sessionStorage.getItem('perfyra-st:' + displayQ) : null;
        if (cached) {
          var cn = parseInt(cached, 10);
          if (cn > 0) {
            window.__perfyraFilteredTotal = cn;
            if (typeof window.PerfyraSyncSearchCounts === 'function') window.PerfyraSyncSearchCounts();
          }
        }
      } catch (e) {}

      if (typeof window.PerfyraFilterSearchResults === 'function') {
        window.PerfyraFilterSearchResults();
      } else if (typeof window.PerfyraSyncSearchCounts === 'function') {
        window.PerfyraSyncSearchCounts();
      }

      var countUrl = location.href;
      window.PerfyraFetchTitleMatchTotal().then(function (n) {
        if (location.href !== countUrl) return;
        if (typeof n !== 'number' || n < 0) return;
        // Facets active → title-matched facet total (not unfiltered cache)
        if (typeof window.PerfyraHasActiveFacets === 'function' && window.PerfyraHasActiveFacets()) {
          window.__perfyraFacetTitleTotal = n;
          if (typeof window.PerfyraSyncSearchCounts === 'function') window.PerfyraSyncSearchCounts();
          return;
        }
        window.__perfyraFilteredTotal = n;
        try {
          if (displayQ) sessionStorage.setItem('perfyra-st:' + displayQ, String(n));
        } catch (e) {}
        if (typeof window.PerfyraSyncSearchCounts === 'function') {
          window.PerfyraSyncSearchCounts();
        }
      });
    };

    window.PerfyraWatchSearchGrid = function () {
      if (location.pathname.indexOf('/search') === -1) return;
      if (window.__perfyraSearchGridWatch) return;
      var grid = document.getElementById('items-grid');
      if (!grid || typeof MutationObserver === 'undefined') return;
      window.__perfyraSearchGridWatch = true;
      var t = null;
      var obs = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (typeof window.PerfyraFilterSearchResults === 'function') window.PerfyraFilterSearchResults();
        }, 50);
      });
      obs.observe(grid, { childList: true, subtree: false });
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('role') !== 'search' && !form.querySelector('input[name="q"]')) return;
      if (!/\/search/.test(form.getAttribute('action') || '') && form.getAttribute('role') !== 'search') return;
      const input = form.querySelector('input[name="q"]:not([type="hidden"])') || form.querySelector('input[name="q"]');
      if (!input || input.disabled) return;

      const typed = window.PerfyraDisplaySearchQuery(input.value) || input.value.trim();
      let expanded = window.PerfyraNormalizeSearchQuery(typed, 'page');
      if (typeof window.PerfyraSafeSearchQuery === 'function') {
        expanded = window.PerfyraSafeSearchQuery(expanded, typed);
      }
      try {
        sessionStorage.setItem('perfyra-search-display', typed);
        if (expanded && expanded !== typed) {
          sessionStorage.setItem('perfyra-search-expanded', expanded);
        } else {
          sessionStorage.removeItem('perfyra-search-expanded');
        }
      } catch (e) {}

      // Bilingual / hamza expansion: load expanded results, then Boot cleans the URL
      if (expanded && expanded !== typed) {
        event.preventDefault();
        const action = form.getAttribute('action') || (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'search' : '/search');
        const params = new URLSearchParams();
        const typeInput = form.querySelector('input[name="type"]');
        const prefixInput = form.querySelector('input[name="options[prefix]"]');
        params.set('q', expanded);
        params.set('type', 'product');
        params.set('options[prefix]', (prefixInput && prefixInput.value) || 'last');
        location.assign(action + (action.indexOf('?') >= 0 ? '&' : '?') + params.toString());
        return;
      }

      // Short query fallback: predictive search can find 2-letter prefixes that
      // the full search page misses. Submit a wildcard query, then keep the
      // clean typed text in the input/UI via PerfyraCleanSearchInputs().
      var simpleTyped = String(typed || '').trim();
      var simpleExpanded = String(expanded || '').trim();
      var shouldWildcard =
        simpleExpanded &&
        simpleExpanded === simpleTyped &&
        simpleTyped.indexOf(' ') === -1 &&
        simpleTyped.indexOf('*') === -1 &&
        simpleTyped.length > 0 &&
        simpleTyped.length < 3 &&
        !/[\u0600-\u06FF]/.test(simpleTyped);

      if (shouldWildcard) {
        event.preventDefault();
        const action = form.getAttribute('action') || (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'search' : '/search');
        const params = new URLSearchParams();
        const typeInput = form.querySelector('input[name="type"]');
        const prefixInput = form.querySelector('input[name="options[prefix]"]');
        params.set('q', simpleTyped + '*');
        params.set('type', 'product');
        params.set('options[prefix]', (prefixInput && prefixInput.value) || 'last');
        try {
          sessionStorage.setItem('perfyra-search-display', simpleTyped);
          sessionStorage.setItem('perfyra-search-expanded', simpleTyped + '*');
        } catch (e) {}
        location.assign(action + (action.indexOf('?') >= 0 ? '&' : '?') + params.toString());
        return;
      }

      if (expanded !== input.value) input.value = expanded;
    }, true);

    // Search page boot — runs once per document (avoids reload loops)
    window.PerfyraBootSearchPage = function () {
      if (window.__perfyraSearchBooted) return;
      if (location.pathname.indexOf('/search') === -1) return;
      window.__perfyraSearchBooted = true;

      var runFilter = function () {
        if (typeof window.PerfyraFilterSearchResults === 'function') {
          queueMicrotask(window.PerfyraFilterSearchResults);
        }
        if (typeof window.PerfyraBootSearchCounts === 'function') {
          // Defer page-count fetches so first paint stays fast
          setTimeout(window.PerfyraBootSearchCounts, 300);
        }
        if (typeof window.PerfyraWatchSearchGrid === 'function') window.PerfyraWatchSearchGrid();
      };

      var params = new URLSearchParams(location.search);
      var q = params.get('q') || '';
      if (!q) {
        window.PerfyraCleanSearchInputs();
        return;
      }

      // Already redirecting from <head> expand script
      if (window.__perfyraSearchExpandRedirected) return;

      // Recover from huge OR URLs that 502 Shopify (e.g. old brand expansions)
      if (typeof window.PerfyraSafeSearchQuery === 'function') {
        var displayQ = window.PerfyraDisplaySearchQuery(q) || q;
        var safeQ = window.PerfyraSafeSearchQuery(q, displayQ);
        if (safeQ && safeQ !== q) {
          try {
            sessionStorage.setItem('perfyra-search-display', displayQ);
            sessionStorage.removeItem('perfyra-search-expanded');
          } catch (e) {}
          location.replace(window.PerfyraBuildSearchUrl(safeQ, params));
          return;
        }
      }

      // Clean URL after expand: only skip re-expand if THIS document was served with OR results.
      if (history.state && history.state.perfyraHamzaExpanded && history.state.servedExpanded) {
        if (window.PerfyraIsExpandedSearchQuery(q)) {
          window.PerfyraCleanSearchInputs(history.state.q || q);
          runFilter();
          return;
        }
      }

      // Stale history.state from a previous visit / reload — ignore and continue
      if (history.state && history.state.perfyraHamzaExpanded && !history.state.servedExpanded) {
        try { history.replaceState(null, '', location.href); } catch (e) {}
      }

      // Ugly OR URL → keep results, clean address bar only (no second navigation)
      if (window.PerfyraIsExpandedSearchQuery(q)) {
        var clean = window.PerfyraCleanSearchUrl();
        window.PerfyraCleanSearchInputs(clean);
        runFilter();
        return;
      }

      // Clean AR or EN brand / hamza link → one expand navigation (bilingual OR)
      var expanded = window.PerfyraNormalizeSearchQuery(q, 'page');
      if (expanded && expanded !== q) {
        try {
          sessionStorage.setItem('perfyra-search-display', window.PerfyraDisplaySearchQuery(q) || q);
          sessionStorage.setItem('perfyra-search-expanded', expanded);
        } catch (e) {}
        location.replace(window.PerfyraBuildSearchUrl(expanded, params));
        return;
      }

      window.PerfyraCleanSearchInputs();
      runFilter();
    };

    queueMicrotask(function () { window.PerfyraBootSearchPage(); });
    document.addEventListener('DOMContentLoaded', function () { window.PerfyraBootSearchPage(); });
    Alpine.store('xSearchDrawer', {
      open: false,
      show() {
        this.open = true;
        document.documentElement.classList.add('x-search-drawer-open');
        document.querySelectorAll('[data-x-search-drawer] .x-search-drawer-overlay').forEach((el) => {
          el.classList.add('is-open');
        });
        document.querySelectorAll('[data-x-search-drawer] .x-search-drawer').forEach((el) => {
          el.classList.remove('popup-hidden');
        });
        const input_search = document.getElementById('search-in-modal')
          || document.getElementById('search-in-modal-mobile')
          || document.getElementById('header-search-in-modal');
        if (input_search) {
          setTimeout(() => input_search.focus(), 100);
        }
      },
      hide() {
        this.open = false;
        document.documentElement.classList.remove('x-search-drawer-open');
        document.querySelectorAll('[data-x-search-drawer] .x-search-drawer-overlay').forEach((el) => {
          el.classList.remove('is-open');
        });
        document.querySelectorAll('[data-x-search-drawer] .x-search-drawer').forEach((el) => {
          el.classList.add('popup-hidden');
        });
        try {
          Alpine.store('xModal')?.removeFocus?.();
        } catch (e) {}
      }
    });

    Alpine.data('xModalSearch', (type, desktopMaximunResults, mobileMaximunResults, productTypeSelected) => ({
      open_search: '',
      t: '',
      result: ``,
      query: '',
      cachedResults: [],
      openResults: false,
      productTypeSelected: productTypeSelected,
      showSuggest: false,
      loading: false,
      get drawerOpen() {
        return Alpine.store('xSearchDrawer')?.open || false;
      },
      getDrawerEl(refName) {
        return this.$refs[refName] || document.getElementById('FormSearch');
      },
      open(refName) {
        Alpine.store('xSearchDrawer').show();
        if (this.$nextTick) {
          this.$nextTick(() => this.getDrawerEl(refName)?.classList.remove('popup-hidden'));
        }
      },
      close(refName) {
        this.showSuggest = false;
        Alpine.store('xSearchDrawer').hide();
        this.getDrawerEl(refName)?.classList.add('popup-hidden');
      },
      /* Shopify sets predictiveSearch:true even for Arabic, but /search/suggest returns 417 */
      supportsPredictiveSearch() {
        const locale = (document.documentElement.lang || window.Shopify?.locale || '').toLowerCase().split('-')[0];
        const unsupported = new Set([
          'ar', 'he', 'fa', 'ur', 'yi',
          'ja', 'zh', 'ko', 'th', 'hi', 'bn', 'ta', 'te', 'ml', 'kn', 'gu', 'pa', 'mr', 'ne', 'si',
          'my', 'km', 'lo', 'am'
        ]);
        if (unsupported.has(locale)) return false;
        if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.predictiveSearch === 'boolean') {
          return window.Shopify.predictiveSearch;
        }
        return true;
      },
      keyUp() {
        this.query = this.$el.value;
        clearTimeout(this.t);
        this.t = setTimeout(() => {
          if (this.query != "") {
            this.showSuggest = false;
            this.getSearchResult(this.query);
          } else {
            this.showSuggest = true;
            this.result = "";
            this.openResults = false;
          }
        }, 300);
      },
      buildPredictiveUrl(q, limit, root) {
        const field = "title,body";
        const base = root != null ? root : Shopify.routes.root;
        /* Products only — never request query suggestions */
        const resourceType = 'product';
        return `${base}search/suggest?q=${encodeURIComponent(q)}&${encodeURIComponent('resources[type]')}=${encodeURIComponent(resourceType)}&${encodeURIComponent('resources[options][fields]')}=${encodeURIComponent(field)}&${encodeURIComponent('resources[limit]')}=${encodeURIComponent(limit)}&section_id=predictive-search`;
      },
      buildFallbackUrl(q) {
        const searchType = 'product';
        return `${Shopify.routes.root}search?q=${encodeURIComponent(q)}&type=${encodeURIComponent(searchType)}&${encodeURIComponent('options[prefix]')}=last&section_id=predictive-search-fallback`;
      },
      /* Drop Suggestions / pages / collections columns — products only */
      stripNonProductResults(html) {
        if (!html) return html;
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<div id="perfyra-strip-root">${html}</div>`, 'text/html');
        const root = doc.getElementById('perfyra-strip-root');
        if (!root) return html;
        root.querySelectorAll('.search-result-query-and-page, #predictive-search-results-queries-list, #predictive-search-queries, #predictive-search-pages, #predictive-search-collections, #predictive-search-articles').forEach((el) => {
          const block = el.closest('.query-and-page-content, .flex-1, .search-result-query-and-page') || el;
          const parent = block.parentElement;
          if (parent && block.id && /collections|articles|pages|queries/i.test(block.id || '')) {
            block.remove();
            return;
          }
          if (el.id === 'predictive-search-collections' || el.id === 'predictive-search-articles' || el.id === 'predictive-search-pages' || el.id === 'predictive-search-queries') {
            const col = el.closest('.flex-1') || el.parentElement;
            if (col) col.remove();
            else el.remove();
            return;
          }
          if (el.classList && el.classList.contains('search-result-query-and-page')) {
            const next = el.nextElementSibling;
            if (next && /border-t|border-l/.test(next.className || '') && !next.classList.contains('predictive-search-others')) next.remove();
            el.remove();
          }
        });
        root.querySelectorAll('.line-spacing').forEach((el) => el.remove());
        return root.innerHTML;
      },
      extractSectionHtml(responseText, sectionId) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, 'text/html');
        const section = doc.getElementById(`shopify-section-${sectionId}`);
        return section ? section.innerHTML : '';
      },
      getSearchResult(query) {
        this.openResults = true;
        const limit = window.xViewport.innerWidth > 767 ? desktopMaximunResults : mobileMaximunResults;
        const localized = (typeof window.PerfyraLocalizeSearchQuery === 'function')
          ? window.PerfyraLocalizeSearchQuery(query)
          : ((typeof window.PerfyraNormalizeSearchQuery === 'function')
            ? window.PerfyraNormalizeSearchQuery(query, 'suggest')
            : query);
        let q = this.productTypeSelected != productTypeSelected ? `${this.productTypeSelected} AND ${localized}` : localized;
        if (!String(q || '').trim()) {
          this.openResults = false;
          this.loading = false;
          return;
        }

        const queryKey = q.split(" ").join("-").toLowerCase() + '_' + limit + '_products';

        if (this.cachedResults[queryKey]) {
          this.result = this.cachedResults[queryKey];
          return;
        }

        this.loading = true;
        const usePredictive = this.supportsPredictiveSearch();
        const requestUrl = usePredictive ? this.buildPredictiveUrl(q, limit) : this.buildFallbackUrl(q);
        const primarySectionId = usePredictive ? 'predictive-search' : 'predictive-search-fallback';
        const logSearchError = (status, url, body) => {
          console.error({
            query,
            localized: q,
            url,
            status,
            responseText: typeof body === 'string' ? body.slice(0, 800) : body
          });
        };

        fetch(requestUrl)
          .then((response) => {
            if (!response.ok) {
              return response.text().then((body) => {
                logSearchError(response.status, requestUrl, body);
                if (usePredictive) {
                  const fallbackUrl = this.buildFallbackUrl(q);
                  return fetch(fallbackUrl).then((fallbackResponse) => {
                    if (!fallbackResponse.ok) {
                      return fallbackResponse.text().then((fbBody) => {
                        logSearchError(fallbackResponse.status, fallbackUrl, fbBody);
                        throw new Error(`Search request failed: ${fallbackResponse.status}`);
                      });
                    }
                    return { text: fallbackResponse.text(), sectionId: 'predictive-search-fallback', url: fallbackUrl };
                  });
                }
                throw new Error(`Search request failed: ${response.status}`);
              });
            }
            return { text: response.text(), sectionId: primarySectionId, url: requestUrl };
          })
          .then(async (payload) => {
            const responseText = await payload.text;
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');
            const section = doc.getElementById(`shopify-section-${payload.sectionId}`);
            if (!section) {
              logSearchError('missing-section', payload.url, responseText);
              return;
            }
            section.querySelectorAll('[data-perfyra-search-haystack]').forEach((item) => {
              if (!window.PerfyraProductMatchesSearch(item.getAttribute('data-perfyra-search-haystack'), query)) item.remove();
            });
            let html = section.innerHTML;
            html = this.stripNonProductResults(html);
            this.result = html;
            this.cachedResults[queryKey] = this.result;
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      setProductType(value, input) {
        this.productTypeSelected = value;
        document.getElementById(input).value = value;
        if(this.query != '') {
          this.getSearchResult(this.query);
        }
      },
      focusForm() {
        if (this.$el.value != '') {
          this.showSuggest = false;
        } else {
          this.showSuggest = true;
        }
      }
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xMobileNav', {
      show: false,
      loading: false,
      currentMenuLinks: [],
      open() {
        this.show = true;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        Alpine.store('xPopup').close();
      },
      setActiveLink(linkId) {
        this.currentMenuLinks.push(linkId);
      },
      removeActiveLink(linkId) {
        const index = this.currentMenuLinks.indexOf(linkId);
        if (index !== -1) {
          this.currentMenuLinks.splice(index, 1);
        }
      },
      resetMenu() {
        this.currentMenuLinks = [];
      },
      scrollTop(el = null) { 
        document.getElementById('menu-navigation').scrollTop = 0; 
        if (el) {
          el.closest('.scrollbar-body').scrollTop = 0;
        }
      }
    });

    Alpine.store('xPopup', {
      open: false,
      widthScrollBar: 0,
      _mqInited: false,
      setWidthScrollbar(firstLoad = true) {
        if (!this._mqInited) {
          this._mqInited = true;
          [1024, 768].forEach((bp) => {
            window.matchMedia(`(max-width: ${bp}px)`).addEventListener('change', () => {
              this.widthScrollBar = 0;
              this.setWidthScrollbar(false);
            });
          });
        }
        window.requestAnimationFrame(() => {
          const root = document.documentElement;
          const clientWidth = root.clientWidth;
          if (firstLoad) {
            const width = Math.abs(window.xViewport.innerWidth - clientWidth);
            window.requestAnimationFrame(() => {
              this.widthScrollBar = Math.max(this.widthScrollBar, width);
              root.style.setProperty('--width-scrollbar', this.widthScrollBar + "px");
            });
          } else {
            const width = Math.abs(window.innerWidth - clientWidth);
            window.requestAnimationFrame(() => {
              this.widthScrollBar = width;
              root.style.setProperty('--width-scrollbar', this.widthScrollBar + "px");
            });
          }
        });
      },
      close() {
        document.dispatchEvent(new CustomEvent("eurus:popup:close"));
        setTimeout(() => {
          this.open = false;
        }, 500);
      }
    }); 

    Alpine.store('xShowCookieBanner', {
      show: false
    });


    Alpine.store('xMiniCart', {
      open: false,
      type: '',
      loading: false,
      needReload: false,
      reLoad() {
        this.loading = true;
        const sections = Alpine.store('xCartHelper').getSectionsToRender().map(s => s.id).join(',');
        fetch(`${window.location.pathname}?sections=${sections}`)
        .then(response => response.json())
        .then(response => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                section.selector.split(',').forEach((selector) => {
                  const sectionElement = document.querySelector(selector);
                  if (sectionElement && response[section.id]) {
                    sectionElement.innerHTML = getSectionInnerHTML(response[section.id], selector);
                  }
                })
              }));
              this.loading = false;
            }, 0)
          });
        });
      },
      openCart() {
        if (window.location.pathname != '/cart') {        
          requestAnimationFrame(() => {
            if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
              Alpine.store('xQuickView').show = false;
            }
          });

          requestAnimationFrame(() => {
            document.getElementById('x-header-container').classList.remove('on-scroll-up-animation');

            if (window.xViewport.innerWidth < 768 || this.type == "drawer") {
              setTimeout(() => {
                Alpine.store('xPopup').open = true;
              }, 50);
            }

            requestAnimationFrame(() => {
              document.getElementById('x-header-container').classList.remove('header-up');
              const container = document.getElementById('x-cart-drawer-container');
              const overlay = document.getElementById('CartDrawer-Overlay');
              const drawer = document.getElementById('CartDrawer');
              if (container) container.style.pointerEvents = 'auto';
              if (drawer) drawer.style.pointerEvents = '';
              if (overlay) {
                overlay.style.display = '';
                overlay.style.pointerEvents = '';
              }
              this.open = true;
              if (document.querySelector(".section-announcement")) {
                document.querySelector(".section-announcement").style.zIndex = 49;
              }
            });
            
            if (Alpine.store('xHeaderMenu').stickyType == 'on-scroll-up') {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  document.getElementById('x-header-container').classList.add('on-scroll-up-animation');
                });
              }, 200);
            }
          });
        }
      },
      hideCart() {
        this.open = false;
        // Close immediately — delayed close left overlay/body lock active and blocked clicks
        if (Alpine.store('xPopup')) {
          Alpine.store('xPopup').open = false;
        }
        requestAnimationFrame(() => {
          const overlay = document.getElementById('CartDrawer-Overlay');
          const drawer = document.getElementById('CartDrawer');
          const container = document.getElementById('x-cart-drawer-container');
          if (overlay) {
            overlay.style.display = 'none';
            overlay.style.pointerEvents = 'none';
          }
          if (drawer) {
            drawer.classList.remove('cart-open');
            drawer.style.pointerEvents = 'none';
          }
          if (container) {
            container.style.pointerEvents = 'none';
          }
          if (document.querySelector(".section-announcement")) {
            setTimeout(() => {
              document.querySelector(".section-announcement").style.zIndex = 60;
            }, 500);
          }
        });
      }
    });

    Alpine.store('xModal', {
      activeElement: "",
      focused: false,
      setActiveElement(element) {
        this.activeElement = element;
      },
      focus(container, elementFocus) {
        this.focused = true;
        window.requestAnimationFrame(() => {
          Alpine.store('xFocusElement').trapFocus(container, elementFocus);
        });
      },
      removeFocus() {
        this.focused = false;
        const openedBy = document.getElementById(this.activeElement);
        Alpine.store('xFocusElement').removeTrapFocus(openedBy);
      }
    });

    Alpine.store('xFocusElement', {
      focusableElements: ['button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'],
      listeners: {},
      windowWidth: window.xViewport.innerWidth,
      trapFocus(container, elementFocus) {
        if ( this.windowWidth < 1025 ) return;

        let c = document.getElementById(container);
        let e = document.getElementById(elementFocus);
        this.listeners = this.listeners || {};
        const elements = Array.from(c.querySelectorAll(this.focusableElements));
        var first = elements[0];
        var last = elements[elements.length - 1];
        
        this.removeTrapFocus();
        
        this.listeners.focusin = (event)=>{
          if (
            event.target !== c &&
            event.target !== last &&
            event.target !== first
          ){
            return;
          }
          document.addEventListener('keydown', this.listeners.keydown);
        };

        this.listeners.focusout = () => {
          document.removeEventListener('keydown', this.listeners.keydown);
        }

        this.listeners.keydown = (e) =>{
          if (e.code.toUpperCase() !== 'TAB') return;
  
          if (e.target === last && !e.shiftKey) {
            e.preventDefault();
            first.focus();
          }
  
          if ((e.target === first || e.target == c) && e.shiftKey) {
            e.preventDefault();
            last.focus();
          }
        }
        document.addEventListener('focusout', this.listeners.focusout);
        document.addEventListener('focusin', this.listeners.focusin);
        window.requestAnimationFrame(() => {
          e.focus();
        });
      },
      removeTrapFocus(elementToFocus = null) {
        if ( window.xViewport.innerWidth < 1025 ) return;

        document.removeEventListener('focusin', ()=>{
          document.addEventListener('keydown', this.listeners.focusin);
        });
        document.removeEventListener('focusout', ()=>{
          document.removeEventListener('keydown', this.listeners.focusout);
        });
        document.removeEventListener('keydown', this.listeners.keydown);
        if (elementToFocus) elementToFocus.focus();
      }
    });
    
    Alpine.store("xEstimateDelivery", {
      day: 0,
      hour: 0,
      minute: 0,
      noti: '',
      _notiKey: '',
      countdownCutOffTime(cutOffHour, cutOffMinute, hrsText, minsText, calculationType, daysText, dayText, hrText, minText, excludeDay, holidayList, currentLanguage) {
        const notiKey = [currentLanguage, cutOffHour, cutOffMinute, hrsText, minsText, hrText, minText, daysText, dayText, calculationType, excludeDay].join('|');
        if (this.noti != '' && this._notiKey === notiKey) return;
        this._notiKey = notiKey;
        this.noti = '';
        const holidayArray = holidayList ? holidayList.split(',').map(holiday => { 
          const parts = holiday.trim().split(' ');
          const day = parts.pop().padStart(2, '0');
          
          return `${parts.join(' ')} ${day}`;
        }) : [];

        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        const current = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentHour, currentMinute);
        const cutOff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutOffHour, cutOffMinute);

        if (current >= cutOff) {
          cutOff.setDate(cutOff.getDate() + 1);
        }
        if (calculationType == 'working') {
          let isInvalid = true;

          while (isInvalid) {
            isInvalid = false;

            if (excludeDay === 'saturday_sunday' && (cutOff.getDay() === 6 || cutOff.getDay() === 0)) {
              if (cutOff.getDay() === 6) {
                cutOff.setDate(cutOff.getDate() + 2);
              } else {
                cutOff.setDate(cutOff.getDate() + 1);
              }
              isInvalid = true;
              continue;
            }

            if (excludeDay === 'saturday' && cutOff.getDay() === 6) {
              cutOff.setDate(cutOff.getDate() + 1);
              isInvalid = true;
              continue;
            }

            if (excludeDay === 'sunday' && cutOff.getDay() === 0) {
              cutOff.setDate(cutOff.getDate() + 1);
              isInvalid = true;
              continue;
            }

            if (holidayArray.length > 0) {
              const dayOfMonth = cutOff.getDate();
              const monthName = new Intl.DateTimeFormat(currentLanguage, { month: "long" }).format(cutOff);
              const dateString = `${monthName} ${dayOfMonth < 10 ? `0${dayOfMonth}` : dayOfMonth}`;

              if (holidayArray.includes(dateString)) {
                cutOff.setDate(cutOff.getDate() + 1);
                isInvalid = true;
                continue;
              }
            }
          }
        }

        const diffMs = cutOff - current;

        this.day = Math.floor(diffMs / 1000 / 60 / 60 / 24);
        this.hour = Math.floor((diffMs / 1000 / 60 / 60) % 24);
        this.minute = Math.floor((diffMs / 1000 / 60) % 60);

        this.noti = this.day > 0 ? this.day + ' ' + (this.day > 1 ? daysText : dayText) + ' ' : ''
        this.noti += this.hour > 0 ? this.hour + ' ' + (this.hour > 1 ? hrsText : hrText) + ' ' + this.minute + ' ' + (this.minute > 1 ? minsText : minText) : this.minute + ' ' + (this.minute > 1 ? minsText : minText);
        return this.noti;
      },
      calculateCutOffTime(el, cutOffHour, cutOffMinute, hrsText, minsText, calculationType, daysText, dayText, hrText, minText, excludeDay, holidayList, currentLanguage) {
        const holidayArray = holidayList ? holidayList.split(',').map(holiday => { 
          const parts = holiday.trim().split(' ');
          const day = parts.pop().padStart(2, '0');

          return `${parts.join(' ')} ${day}`;
        }) : [];

        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        const current = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentHour, currentMinute);
        const cutOff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutOffHour, cutOffMinute);

        if (current >= cutOff) {
          cutOff.setDate(cutOff.getDate() + 1);
        }

        if (calculationType == 'working') {
          let isInvalid = true;

          while (isInvalid) {
            isInvalid = false;

            if (excludeDay === 'saturday_sunday' && (cutOff.getDay() === 6 || cutOff.getDay() === 0)) {
              if (cutOff.getDay() === 6) {
                cutOff.setDate(cutOff.getDate() + 2);
              } else {
                cutOff.setDate(cutOff.getDate() + 1);
              }
              isInvalid = true;
              continue;
            }

            if (excludeDay === 'saturday' && cutOff.getDay() === 6) {
              cutOff.setDate(cutOff.getDate() + 1);
              isInvalid = true;
              continue;
            }

            if (excludeDay === 'sunday' && cutOff.getDay() === 0) {
              cutOff.setDate(cutOff.getDate() + 1);
              isInvalid = true;
              continue;
            }

            if (holidayArray.length > 0) {
              const dayOfMonth = cutOff.getDate();
              const monthName = new Intl.DateTimeFormat(currentLanguage, { month: "long" }).format(cutOff);
              const dateString = `${monthName} ${dayOfMonth < 10 ? `0${dayOfMonth}` : dayOfMonth}`;

              if (holidayArray.includes(dateString)) {
                cutOff.setDate(cutOff.getDate() + 1);
                isInvalid = true;
                continue;
              }
            }
          }
        }

        const diffMs = cutOff - current;
        
        const day = Math.floor(diffMs / 1000 / 60 / 60 / 24);
        const hour = Math.floor((diffMs / 1000 / 60 / 60) % 24);
        const minute = Math.floor((diffMs / 1000 / 60) % 60);
        let noti = day > 0 ? day + ' ' + (day > 1 ? daysText : dayText) + ' ' : ''
        noti += hour > 0 ? hour + ' ' + (hour > 1 ? hrsText : hrText) + ' ' + minute + ' ' + (minute > 1 ? minsText : minText) : minute + ' ' + (minute > 1 ? minsText : minText);

        this.noti = noti;

        el.value = el.value.replace('time_to_cut_off', noti);
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xCartAnalytics', {
      viewCart() {
        fetch(
          '/cart.js'
        ).then(response => {
          return response.text();
        }).then(cart => {
          cart = JSON.parse(cart);
          if (cart.items.length > 0) {
            Shopify.analytics.publish('view_cart', {'cart': cart});
          }
        });
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xCustomerEvent', {
      fire(eventName, el, data) {
        if (Shopify.designMode) return;
        
        const formatedData = data ? data : xParseJSON(el.getAttribute('x-customer-event-data'));
        Shopify.analytics.publish(eventName, formatedData);
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xSplide', {
      load(el, configs) {
        const initSlider = () => {
          const id = el.getAttribute("id");
          if(configs.classes != undefined) {
            if (!configs.classes.arrow) configs.classes.arrow = "arrow w-8 h-8 pt-2 pb-2 pl-2 pr-2 absolute z-10 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center";
            if (!configs.classes.next) configs.classes.next = "right-0";
            if (!configs.classes.prev) configs.classes.prev = "-rotate-180";
          }
          let splide = new Splide("#" + id, configs);
          if (configs.thumbs) {
            let thumbsRoot = document.getElementById(configs.thumbs);
            let thumbs = thumbsRoot.getElementsByClassName('x-thumbnail');
            let current;
            let _this = this;

            for (let i = 0; i < thumbs.length; i++) {
              if (thumbs[i] == current) {
                if (configs.enableThumbnailOverlay) {
                  thumbs[i].classList.remove('opacity-30');
                  thumbs[i].classList.add('quickview-border');
                } else {
                  thumbs[i].classList.add('border');
                }
              } else {
                if (configs.enableThumbnailOverlay) {
                  thumbs[i].classList.add('opacity-30');
                  thumbs[i].classList.remove('quickview-border');
                } else {
                  thumbs[i].classList.remove('border');
                }
              }
              thumbs[i].addEventListener('click', function () {
                _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                splide.go(i);
              });
            }

            splide.on('refresh', function () {
              for (let i = 0; i < thumbs.length; i++) {
                thumbs[i].removeEventListener('click', function () {
                  _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                  splide.go(i);
                });
              }

              let thumbsRoot = document.getElementById(configs.thumbs);
              let thumbsNew = thumbsRoot.getElementsByClassName('x-thumbnail');

              for (let i = 0; i < thumbsNew.length; i++) {
                if (i == 0) {
                  if (configs.enableThumbnailOverlay) {
                    thumbsNew[i].classList.remove('opacity-30');
                    thumbsNew[i].classList.add('quickview-border');
                  } else {
                    thumbsNew[i].classList.add('border');
                  }
                } else {
                  if (configs.enableThumbnailOverlay) {
                    thumbsNew[i].classList.add('opacity-30');
                    thumbsNew[i].classList.remove('quickview-border');
                  } else {
                    thumbsNew[i].classList.remove('border');
                  }
                }
                
                thumbsNew[i].addEventListener('click', function () {
                  _this.moveThumbnail(i, thumbsNew[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                  splide.go(i);
                });
              }
            })
            splide.on('mounted move', function () {
              let thumbnail = thumbs[splide.index];
              if (thumbnail) {
                if (current) {
                  if (configs.enableThumbnailOverlay) {
                    current.classList.add('opacity-30');
                    current.classList.remove('quickview-border');
                  } else {
                    current.classList.remove('border');
                  }
                }
                if (configs.enableThumbnailOverlay) {
                  thumbnail.classList.remove('opacity-30');
                  thumbnail.classList.add('quickview-border');
                } else {
                  thumbnail.classList.add('border')
                }
                current = thumbnail;
                _this.moveThumbnail(splide.index, thumbnail, thumbsRoot, configs.thumbs_direction, configs.direction);
              }
            });
          }

          if (configs.hotspot) {
            let hotspotRoot = document.getElementById(configs.hotspot);
            let hotspots = hotspotRoot.getElementsByClassName('x-hotspot');
            let current;

            if (configs.disableHoverOnTouch && (('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints)) {
              for (let i = 0; i < hotspots.length; i++) {
                hotspots[i].addEventListener('click', function () {
                  splide.go(i);
                });
              }
            } else {
              for (let i = 0; i < hotspots.length; i++) {
                hotspots[i].addEventListener('mouseover', function () {
                  splide.go(i);
                });
                hotspots[i].addEventListener('focus', function () {
                  splide.go(i);
                });
              }             
            }
            splide.on('mounted move', function () {
              let hotspot = hotspots[splide.index];
              
              if (hotspot) {
                if (current) {
                  current.classList.remove('active-hotspot');
                }
                hotspot.classList.add('active-hotspot');
                current = hotspot;
              }
            });
          }
          if (configs.cardHover) {
            let cardImage = document.getElementById(configs.cardHover);
            if (window.xViewport.innerWidth > 1024) {
              cardImage.addEventListener('mousemove', function (e) {
                let left = e.offsetX;
                let width = cardImage.getBoundingClientRect().width;
                let spacing = left / width;
                let index = Math.floor(spacing * configs.maxSlide);
                splide.go(index);
              });
              cardImage.addEventListener('mouseleave', function (e) {
                splide.go(0);
              });
            }
          }
          if (configs.progressBar) {
            var bar = splide.root.querySelector( '.splide-progress-bar' );
            splide.on( 'mounted move', function () {
              var end  = configs.progressBar;
              if (configs.progressBarHeader) {
                end  = splide.Components.Slides.getLength();
              }
              var rate = 100 * (splide.index / end);
              if (bar) {
                var widthBar =  window.getComputedStyle(bar).getPropertyValue('width').replace("px", '');
                var widthProgressBar = window.getComputedStyle(bar.closest('.splide-progress')).getPropertyValue('width').replace("px", '');
                var percentBar = 100 * (Number(widthBar) /  Number(widthProgressBar));
                var rateBar = rate + percentBar;
                var maxRate = 100 - percentBar;
                if (rateBar > 100 ) {
                  rate = maxRate;
                }
                if (document.querySelector('body').classList.contains('rtl')) {
                  bar.style.marginRight = rate + '%';
                } else {
                  bar.style.marginLeft = rate + '%';
                }  
              }
            });
            var progressBar = splide.root.querySelector( '.splide-progress' );
            progressBar?.addEventListener('click', function (e) {
              var rect = progressBar.getBoundingClientRect();
              var clickX = e.clientX - rect.left;
              var percent = clickX / rect.width;
              var totalPages = Math.ceil(splide.length / splide.options.perPage);
              var page = Math.floor(percent * totalPages);
              if (page >= totalPages) page = totalPages - 1;
              var index = page * splide.options.perPage;
              splide.go(index);
            });
          }
          if(el.classList.contains('card-product-img')) {
            splide.on('resized', function() { 
              var height = splide.root.querySelector('.splide__track').offsetHeight;
              splide.Components.Slides.get().forEach((item) => {
                item.slide.style.height = height+"px";
              });
            }) 
          }

          if (configs.events) {
            configs.events.forEach((e) => {
              splide.on(e.event, e.callback);
            });
          }

          
          el.splide = splide;
          splide.mount();
          if (configs.videoProduct) {
            const move = splide.Components.Move;
            move.translate(move.toPosition(0));  
          }

          if (configs.playOnHover) {
            const breakPoint = window.matchMedia('(min-width: 1024px)');
            breakPoint.addEventListener('change', () => {
              if (breakPoint.matches) splide.Components.Autoplay.pause();
            })
          }

          if (configs.playOnHover && window.innerWidth > 1024) {
            splide.Components.Autoplay.pause();
            el.onmouseover = function() {
              splide.Components.Autoplay.play();
            };
            el.onmouseout = function() {
              splide.Components.Autoplay.pause();
            };
          }
        }

        if (window.Splide) {
          initSlider();
        } else {
          window.addEventListener('load', initSlider, { once: true });
        }
      },
      togglePlayPause(el) {
        if (!el || !el.splide || !el.splide.Components.Autoplay) return;
      
        const splide = el.splide;
        const autoplay = splide.Components.Autoplay;
      
        if (autoplay.isPaused()) {
          autoplay.play();
        } else {
          splide.go(0);
          autoplay.pause();
        }
      },
      moveThumbnail(index, thumbnail, thumbsRoot, direction) {
        if (thumbnail) {
          if (direction == 'vertical') {
            const thumbnailHeight = thumbnail.offsetHeight;
            const rootHeight = thumbsRoot.offsetHeight;
            setTimeout(() => {
              window.requestAnimationFrame(() => {
                thumbsRoot.scrollTop = (index + 1) * thumbnailHeight - rootHeight * 0.5 + thumbnailHeight * 0.5 + index * 6;
              })
            },50);
          } else {
            thumbsRoot.scrollLeft = (index - 2) * thumbnail.offsetWidth;
          }
        }
      },
      jumpToLast(el) {
        const splide = el.splide;
        const controller = splide.Components.Controller;

        const index = controller.getEnd() + 2
        splide.go(index);
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xParallax', () => ({
      debounce(func, wait) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
              timeout = null;
              func.apply(context, args);
            };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      },
      load(disable) {
        if (disable) return;

        if ("IntersectionObserver" in window && 'IntersectionObserverEntry' in window) {
          const observerOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0
          };

          var observer = new IntersectionObserver(handleIntersect, observerOptions);
          var el;
          function handleIntersect(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                el = entry.target;
                window.addEventListener('scroll', parallax, {passive: true, capture: false});
              } else {
                window.removeEventListener('scroll', parallax, {passive: true, capture: false});
              }
            });
          }

          observer.observe(this.$el);
          
          var parallax = this.debounce(function() {
            var rect = el.getBoundingClientRect();
            var speed = (window.xViewport.innerHeight / el.parentElement.offsetHeight) * 20;
            var shiftDistance = (rect.top - window.xViewport.innerHeight) / speed;
            var maxShiftDistance = el.parentElement.offsetHeight / 11;
            
            if (shiftDistance < -maxShiftDistance || shiftDistance > maxShiftDistance) {
              shiftDistance = -maxShiftDistance;
            }
            
            requestAnimationFrame(() => {
              el.style.transform = 'translate3d(0, '+ shiftDistance +'px, 0)';
            })
          }, 10);
        }
      }
    }));
  });
});

requestAnimationFrame(() => {
  // Optimize INP
  document.addEventListener('alpine:init', () => {
    Alpine.store('xDOM', {
      rePainting: null, // String: alias element re-painting.
    })
  })
})

requestAnimationFrame(() => {
  document.addEventListener('eurus:cart:reload', () => {
    if (window.location.pathname !== '/cart'){
      Alpine.store('xMiniCart').reLoad();
      console.log('Mini cart has been reloaded');
    } else {
      Alpine.store('xCartHelper').reRenderSections();
      console.log('Cart has been reloaded');
    }
  })
})
